@if (suggestions().length) {
  <div class="chat-suggestion-bar w-full min-w-0 flex-shrink-0">
    <div class="chat-suggestion-bar__label">
      <i class="pi pi-bolt chat-suggestion-bar__bolt" aria-hidden="true"></i>
      <span class="chat-suggestion-bar__title">Suggestions</span>
    </div>
    <div
      class="chat-suggestion-bar__chips"
      role="list"
      aria-label="Suggested prompts"
    >
      @for (s of displayedChips(); track s.key) {
        <p-chip
          role="listitem"
          [label]="s.cta"
          [removable]="false"
          [disabled]="chipsDisabled()"
          styleClass="chat-suggestion-chip"
          (click)="onChipClick(s.macro)"
        ></p-chip>
      }
      @if (showViewAll()) {
        <button
          type="button"
          #viewAllAnchor
          class="chat-suggestion-view-all"
          [disabled]="chipsDisabled()"
          aria-haspopup="dialog"
          aria-label="View all suggestions"
          (click)="togglePopover($event, viewAllAnchor)"
        >
          View all
        </button>
      }
    </div>
  </div>

  <!--
    PrimeNG 21: project content as direct children (or ng-template #content).
    Using pTemplate="content" does not populate the overlay — see primeng.org/popover.
  -->
  <p-popover
    #suggestionsPopover
    [appendTo]="'body'"
    styleClass="chat-suggestions-popover-panel"
    ariaLabel="More suggestions"
  >
    <div class="chat-suggestions-popover-body">
      <div class="chat-suggestions-popover-title">More suggestions</div>
      <div
        class="chat-suggestions-popover-chips"
        role="list"
        aria-label="Additional suggested prompts"
      >
        @for (s of popoverChips(); track s.key) {
          <p-chip
            role="listitem"
            [label]="s.cta"
            [removable]="false"
            [disabled]="chipsDisabled()"
            styleClass="chat-suggestion-chip"
            (click)="onChipClick(s.macro)"
          ></p-chip>
        }
      </div>
    </div>
  </p-popover>
}
